import { render, staticRenderFns } from "./index-social-marketing.vue?vue&type=template&id=c2830a08&"
import script from "./index-social-marketing.vue?vue&type=script&lang=js&"
export * from "./index-social-marketing.vue?vue&type=script&lang=js&"
import style0 from "./index-social-marketing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports